import * as React from 'react'
import { QueryClientProvider } from 'react-query'
import buildQueryClient from '../helpers/queryClient'
import CommonContext from '../CommonContext'
import AdjustmentsFormFields from "./AdjustmentsFormFields";

export default function AdjustmentsFormFieldsApp(props: any) {
  const queryClient = buildQueryClient()
  const {
    adjustment,
    availableWorktypes,
    availableMachines,
    availableWarehouses,
    hideMachines,
    hideItems,
    hidePackagings,
    dynamicsnavPrefix,
    currentUser,
  } = props

  return (
    <CommonContext.Provider value={{ dynamicsnavPrefix, currentUser }}>
      <QueryClientProvider client={queryClient}>
        <AdjustmentsFormFields
          adjustment={adjustment}
          availableWorktypes={availableWorktypes}
          availableMachines={availableMachines}
          availableWarehouses={availableWarehouses}
          hideMachines={hideMachines}
          hideItems={hideItems}
          hidePackagings={hidePackagings}
        />
      </QueryClientProvider>
    </CommonContext.Provider>
  )
}
